import {Component, Input, OnInit} from '@angular/core';
import {floor} from 'lodash';
import {OptionConsumptionModel} from '../../../../../core-logic/models/shared/options-consumption/option-consumption-model';
import moment from 'moment';
import {OptionsTypeList} from '../../../../../common/enums/options-type-list';

@Component({
  selector: 'app-option-consumption-item',
  templateUrl: './option-by-unit-consumption-item.component.html',
  styleUrls: ['./option-by-unit-consumption-item.component.scss'],
})
export class OptionByUnitConsumptionItemComponent implements OnInit {
  @Input() optionConsumption: OptionConsumptionModel
  optionMonthlyPrice: number;
  constructor() { }

  ngOnInit() {
    this.optionMonthlyPrice = floor(this.optionConsumption?.daily_pricing * this.optionConsumption?.day_in_month_count, 2);
  }

  get optionsTypeList() { return OptionsTypeList; }

  getOptionDailyCost(): number {
    return floor(this.optionConsumption?.paying_option_count * this.optionConsumption?.daily_pricing, 2);
  }

  formatDateInterval(): string {
    return `${moment(this.optionConsumption?.period?.start_date).format('D MMM')} - ${moment(this.optionConsumption?.period?.end_date)
      .format('D MMM')}`;
  }

  getOptionTexts(): {free: string; paid: string} {
    switch (this.optionConsumption?.type.toString()) {
      case OptionsTypeList.REWARD:
        return {
          free: this.optionConsumption?.free_option_count > 1 ? `${this.optionConsumption?.free_option_count} récompenses gratuites` :
            `${this.optionConsumption?.free_option_count} récompense gratuite`,
          paid: this.optionConsumption?.paying_option_count > 1 ? `${this.optionConsumption?.paying_option_count} récompenses payantes` :
            `${this.optionConsumption?.paying_option_count} récompense payante`
        };
      case OptionsTypeList.MEMBER:
        return {
          free: this.optionConsumption?.free_option_count > 1 ? `${this.optionConsumption?.free_option_count} membres gratuits` :
            `${this.optionConsumption?.free_option_count} membre gratuit`,
          paid: this.optionConsumption?.paying_option_count > 1 ? `${this.optionConsumption?.paying_option_count} membres payants` :
            `${this.optionConsumption?.paying_option_count} membre payant`
        };
      case OptionsTypeList.TAG:
        return {
          free: this.optionConsumption?.free_option_count > 1 ? `${this.optionConsumption?.free_option_count} badges gratuits` :
            `${this.optionConsumption?.free_option_count} badge gratuit`,
          paid: this.optionConsumption?.paying_option_count > 1 ? `${this.optionConsumption?.paying_option_count} badges payants` :
            `${this.optionConsumption?.paying_option_count} badge payant`
        };
      case OptionsTypeList.PROMOTION:
        return {
          free: this.optionConsumption?.free_option_count > 1 ? `${this.optionConsumption?.free_option_count} actualités gratuites` :
            `${this.optionConsumption?.free_option_count} actualité gratuite`,
          paid: this.optionConsumption?.paying_option_count > 1 ? `${this.optionConsumption?.paying_option_count} actualités payantes` :
            `${this.optionConsumption?.paying_option_count} actualité payante`
        };
    }
  }
}
